import { render, staticRenderFns } from "./profile-page.vue?vue&type=template&id=17d6d19c&scoped=true&"
import script from "./profile-page.vue?vue&type=script&lang=js&"
export * from "./profile-page.vue?vue&type=script&lang=js&"
import style0 from "./profile-page.vue?vue&type=style&index=0&id=17d6d19c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d6d19c",
  null
  
)

export default component.exports